module.exports = __webpack_public_path__ + "static/media/gothenburg_horse_show_logo.ceeb99e8.svg";